import React from 'react';
import './CoChairsPage.css';

// Images exported from the Figma Dev-Mode code
import imgProfJieYang from "../assets/cochairs/ProfJieYang.png";
import imgProfAlexNg from "../assets/cochairs/ProfAlexNg.png";
import imgProfChenMingWang from "../assets/cochairs/ProfChenMingWang.png";
import imgProfKitipornchai from "../assets/cochairs/ProfKitipornchai.png";
import imgProfJohnnyHo from "../assets/cochairs/ProfJohnnyHo.png";
import imgProfVinhDao from "../assets/cochairs/ProfVinhDao.png";
import imgBillyLao from "../assets/cochairs/BillyLao.jpg";

const coChairs = [
  {
    name: 'Prof Jie Yang',
    role: 'Lead Editor in Chief, Engineering Structures',
    image: imgProfJieYang,
    url: 'https://www.rmit.edu.au/profiles/y/jie-yang'
  },
  {
    name: 'Prof Alex Ng',
    role: 'Editor in Chief, Engineering Structures',
    image: imgProfAlexNg,
    url: 'https://researchers.adelaide.edu.au/profile/alex.ng'
  },
  {
    name: 'Prof Chien Ming Wang',
    role: 'University of Queensland',
    image: imgProfChenMingWang,
    url: 'https://about.uq.edu.au/experts/16698'
  },
  {
    name: 'Prof Sritawat Kitipornchai',
    role: 'University of Queensland',
    image: imgProfKitipornchai,
    url: 'https://about.uq.edu.au/experts/576'
  },
];

const viceChairs = [
  {
    name: 'A.Prof Johnny Ho',
    role: 'University of Queensland',
    image: imgProfJohnnyHo,
    url: 'https://about.uq.edu.au/experts/8052'
  },
  {
    name: 'A.Prof Vinh Dao',
    role: 'University of Queensland',
    image: imgProfVinhDao,
    url: 'https://about.uq.edu.au/experts/2148'
  },
];

const conferenceManagers = [
  {
    name: 'Mr. Weng Chong (Billy) LAO',
    role: 'University of Queensland',
    image: imgBillyLao,
    url: 'https://www.linkedin.com/in/wengchong-lao/'
  },
];


const CoChairsPage = () => (
  <section className="cochairs-page fade-in-up">
    <div className="container-small">
      <span className="badge cochairs-badge">Organising Committee</span>
      <h1 className="cochairs-heading">Co-Chairs</h1>

      <div className="chairs-grid">
        {coChairs.map((chair) => (
          <a key={chair.name} href={chair.url} target="_blank" rel="noopener noreferrer" className="chair-link">
            <figure className="chair-card">
              <img src={chair.image} alt={chair.name} className="chair-photo" />
              <figcaption>
                <p className="chair-name">{chair.name}</p>
                <p className="chair-role">{chair.role}</p>
              </figcaption>
            </figure>
          </a>
        ))}
      </div>
    </div>

    <div className="vice-section">
      <div className="container-small">
        <h2 className="vice-heading">Co-Vice-Chairs</h2>
        <div className="vice-grid">
          {viceChairs.map((chair) => (
            <a key={chair.name} href={chair.url} target="_blank" rel="noopener noreferrer" className="chair-link">
              <figure className="chair-card">
                <img src={chair.image} alt={chair.name} className="chair-photo" />
                <figcaption>
                  <p className="chair-name">{chair.name}</p>
                  <p className="chair-role">{chair.role}</p>
                </figcaption>
              </figure>
            </a>
          ))}
          </div>
        </div>
      </div>

    <div className="manager-section" id="conference-manager">
      <div className="container-small">
        <h2 className="manager-heading">Conference Manager</h2>
        <div className="manager-grid">
          {conferenceManagers.map((person) => (
            <a key={person.name} href={person.url} target="_blank" rel="noopener noreferrer" className="chair-link">
              <figure className="chair-card">
                {person.image ? (
                  <img src={person.image} alt={person.name} className="chair-photo" />
                ) : (
                  <div className="chair-photo-placeholder">
                    <span>{person.name.split(' ').map(n => n[0]).join('')}</span>
                  </div>
                )}
                <figcaption>
                  <p className="chair-name">{person.name}</p>
                  <p className="chair-role">{person.role}</p>
                </figcaption>
              </figure>
            </a>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default CoChairsPage;
